import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface UpdateCommentInput {
  PK: string
  SK: string
  updates: {
    fieldName: string
    newValue: any
  }[]
}

export const useUpdateComment = (): UseMutationResult<any, Error, UpdateCommentInput> => {
  const mutation = useMutation({
    mutationFn: async ({ PK, SK, updates }: UpdateCommentInput) => {
      const response = await axios.post(`${baseUrl}/aws/comments/update-comment`, {
        PK,
        SK,
        updates,
      })
      return response.data
    },
  })
  return mutation
}
